var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.wpBussChannelDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp_business_api.manageChannelDetail"))),
        ]),
      ]),
      _vm._v(" "),
      _vm.shouldShowOnboarding
        ? [
            _c("div", { staticClass: "onboarding-wrapper" }, [
              _c(
                "div",
                { staticClass: "facebook-signup-container" },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("Kurulumu Tamamla")))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(
                            "WhatsApp Business API kurulumunu tamamlamak için lütfen aşağıdaki butona tıklayarak bağlantı sayfasına gidin."
                          )
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center my-4" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", size: "large" },
                          on: { click: _vm.redirectToConnectPage },
                        },
                        [
                          _c("a-icon", { attrs: { type: "link" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("WhatsApp Business Hesabını Bağla")
                              ) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-alert", {
                    staticClass: "mt-4",
                    attrs: {
                      message: _vm.$t("Bilgilendirme"),
                      description: _vm.$t(
                        "WhatsApp Business API kurulumu için Facebook Business hesabınızın ve WhatsApp numaranızın hazır olması gerekmektedir."
                      ),
                      type: "info",
                      "show-icon": "",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        : [
            _c("a-form", [
              _c("div", { staticClass: "form-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.channelName"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.channelName"
                        ),
                        name: "channelName",
                      },
                      model: {
                        value: _vm.clone.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "name", $$v)
                        },
                        expression: "clone.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [_vm._v("Business ID")]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: "Business ID",
                        value: _vm.clone.payload.business_id,
                        disabled: "",
                        name: "businessId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [_vm._v("Phone Number ID")]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: "Phone Number ID",
                        value: _vm.clone.payload.phone_number_id,
                        disabled: "",
                        name: "phoneNumberId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [_vm._v("WABA ID")]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: "WABA ID",
                        value: _vm.clone.payload.waba_id,
                        disabled: "",
                        name: "wabaId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-wrapper" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.phoneNumberE164"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.phoneNumberE164Place"
                        ),
                        value: _vm.clone.payload.phoneNumber,
                        disabled: "",
                        name: "phoneNumber",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.clone.payload.verifiedName
                  ? _c(
                      "div",
                      { staticClass: "input-wrapper" },
                      [
                        _c("label", [_vm._v("Verified Name")]),
                        _vm._v(" "),
                        _c("a-input", {
                          attrs: {
                            placeholder: "Verified Name",
                            value: _vm.clone.payload.verifiedName,
                            disabled: "",
                            name: "verifiedName",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("ChannelForwardSetting", {
              attrs: { channel: _vm.clone },
              on: {
                input: function (c) {
                  return (_vm.clone = c)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "form-footer" }, [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary", disabled: _vm.loading },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.update")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }